document.addEventListener("DOMContentLoaded", function () {
  initializeAddOnDialogs();
});
window.addEventListener("resize", handleAddonToggleReszize);

function initializeAddOnDialogs() {
  const toggleList = document.querySelector(".ombraz-v2pdp__addon-toggle-list");

  const dialogOpeners = document.querySelectorAll(
    ".ombraz-v2pdp__dialog-opener"
  );

  if (!toggleList || !dialogOpeners) return;

  let activeDialog = null;

  function openDialog(dialog) {
    dialog.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    const closeButton = dialog.querySelector(".ombraz-v2pdp__dialog-close");
    closeButton.focus();
    activeDialog = dialog;
  }

  function closeDialog(dialog) {
    dialog.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    const opener = document.querySelector(`[data-dialog-id="${dialog.id}"]`);
    opener.focus();
    activeDialog = null;

    const isSmallDevice = window.matchMedia("(max-width: 1198px)").matches;

    if (isSmallDevice) {
      document
        .querySelector(".ombraz-v2pdp__addon-toggle-list")
        ?.style.setProperty("display", "none", "important");
    } else {
      document
        .querySelector(".ombraz-v2pdp__addon-toggle-list")
        ?.style.setProperty("display", "grid", "important");
    }
  }

  function handleEscapeKey(event) {
    if (event.key === "Escape" && activeDialog) {
      closeDialog(activeDialog);
    }
  }

  function trapFocus(event) {
    if (!activeDialog) return;

    const focusableElements = activeDialog.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.key === "Tab") {
      if (event.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          event.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          event.preventDefault();
        }
      }
    }
  }

  toggleList.addEventListener("click", function (event) {
    const clickedElement = event.target.closest("[data-dialog-id]");

    if (!clickedElement) return;

    const dialogId = clickedElement.getAttribute("data-dialog-id");
    const dialog = document.getElementById(dialogId);

    if (dialog) {
      openDialog(dialog);
    }
  });

  dialogOpeners.forEach((opener) => {
    const dialogId = opener.getAttribute("data-dialog-id");
    const dialog = document.getElementById(dialogId);
    if (dialog) {
      const closeButton = dialog.querySelector(".ombraz-v2pdp__dialog-close");
      const overlay = dialog.querySelector(".ombraz-v2pdp__dialog-overlay");

      opener.addEventListener("click", () => openDialog(dialog));
      closeButton.addEventListener("click", () => closeDialog(dialog));
      overlay.addEventListener("click", () => closeDialog(dialog));
    }
  });

  document.addEventListener("keydown", handleEscapeKey);
  document.addEventListener("keydown", trapFocus);
}

function handleAddonToggleReszize() {
  const isSmallDevice = window.matchMedia("(max-width: 1198px)").matches;
  const addonToggleList = document.querySelector(
    ".ombraz-v2pdp__addon-toggle-list"
  );

  if (isSmallDevice) {
    addonToggleList.style.setProperty("display", "none", "important");
  } else {
    addonToggleList.style.setProperty("display", "grid", "important");
  }
}
